import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';

import TextareaField from '../../../shared/form-elements/textarea';

const Form = ({ intl, notePopupData, noteData, handleSubmit, submitNote, deleteNote, toggleNotePopup }) => (
	<form
		className="margin-0-10 display-flex-column top-affiliate-note-form"
		onSubmit={handleSubmit(data => submitNote({ ...notePopupData, ...data }))}
	>
		<div>
			<a
				href="#"
				className="modal-close"
				onClick={e => {
					toggleNotePopup();
					e.preventDefault();
				}}
			></a>
		</div>
		{
			noteData && noteData
				.filter(() => !!notePopupData)
				.filter(note => notePopupData.affiliate_id === note.affiliate_id)
				.filter(note => notePopupData.offer_id === note.offer_id)
				.filter(note => notePopupData.country_code === note.country_code)
				.filter(note => notePopupData.date === note.date)
				.map((note, index) =>
					<p key={index} className="padding-5-15 flex-center justify-start" >
						<span>{note.comment && note.comment.split('\n').map((item, key) => <p key={key}>{item}</p>)}</span>
						<span className="action_delete margin-0-15" onClick={deleteNote.bind(null, note.id)}/>
					</p>
				)
		}
		<div className="flex-center justify-start">
			<div className="note-form-comment-container margin-10-0 width-500">
				<Field
					name="comment"
					placeholder={intl('Comment')}
					showLabel={false}
					initialHeight={50}
					minHeight={50}
					component={TextareaField} />
			</div>
			<button className="ui-btn ui-btn-primary width-150 margin-0-15">
				{intl('Save')}
			</button>
		</div>
	</form>
);

class FormContainer extends Component {
	constructor(props) {
		super(props);
	}
	componentWillUnmount() {
		document.querySelector('.top-affiliate-note-form').removeEventListener('copy', handleCopyFromPopup);
	}
	componentDidMount() {
		document.querySelector('.top-affiliate-note-form').removeEventListener('copy', handleCopyFromPopup);
		document.querySelector('.top-affiliate-note-form').addEventListener('copy', handleCopyFromPopup);
	}

	render() {
		return <Form {...this.props} />;
	}
}

function handleCopyFromPopup(e) {
	e.stopPropagation();
	const text = window.getSelection().toString();
	e.clipboardData.setData('text/plain', text);
	e.preventDefault();
}

export default reduxForm({})(FormContainer);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/top-affiliates/components/form/note-form.js